var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _vm._v("基础信息")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [_vm._v(_vm._s(_vm.comUserInfo.name || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.departId,
                    callback: function($$v) {
                      _vm.departId = $$v
                    },
                    expression: "departId"
                  }
                },
                _vm._l(_vm.comUserInfo.departs, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                })
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.bizVoucherId != null
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("附件信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "file-area1 clearfix" }, [
              _c(
                "div",
                {
                  staticClass:
                    "file-item1 deletable viewable downloadable editable"
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-content" }, [
                    _vm.bizTypeCode == "retailer.assets.purch"
                      ? _c("p", { staticClass: "file-name" }, [
                          _vm._v("请购单据明细.xlsx")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bizTypeCode == "retailer.assets.allot"
                      ? _c("p", { staticClass: "file-name" }, [
                          _vm._v("调拨单据明细.xlsx")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bizTypeCode == "retailer.assets.scrap"
                      ? _c("p", { staticClass: "file-name" }, [
                          _vm._v("报废单据明细.xlsx")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bizTypeCode == "retailer.assets.clear"
                      ? _c("p", { staticClass: "file-name" }, [
                          _vm._v("清除单据明细.xlsx")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-opera" }, [
                    _c("i", {
                      staticClass: "icon iconfont icon-xiazai download",
                      on: {
                        click: function($event) {
                          _vm.dowmloadFile()
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发起人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发起部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-icon" }, [
      _c("i", { staticClass: "file-type-icon doc small" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cb47d1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb47d1f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/oaAudit/DingDingAuditView.vue
// module id = 2546
// module chunks = 0